module.exports = __webpack_public_path__ + "static/media/ic_chevron-left-primary.85f80287.svg";